'use strict';

function addMainDataInSIComp ($element, data, dataLength) {
  var $content;
  var visualBaseUrl;
  var visualCompUrl;
  var objUrl = $element.find('h4').text();
  var baseData = data[window.currentWebsite];
  var compData = data[objUrl];
  var maxUrlLength = 18;

  if ((baseData != null) && (compData != null)) {
    visualBaseUrl = (baseData.url.length < maxUrlLength)
      ? baseData.url : baseData.url.substr(0, maxUrlLength - 3) + '...';

    visualCompUrl = (compData.url.length < maxUrlLength)
      ? compData.url : compData.url.substr(0, maxUrlLength - 3) + '...';

    $content = $(
      '<table class=" table table-thinhead table-striped social-media-compare comp-' + compData.id + '">' +
      '<thead><tr><th></th><th><span class="color"></span>' +
      visualBaseUrl + '</th><th><span class="color"></span>' +
      visualCompUrl + '</th></tr></thead><tbody></tbody></table>'
    );

    $element.find('p span.big-right-aligned').each(function () {
      var baseTd;
      var compTd;
      var line;
      var socialMediaObj = $(this);
      var socialMediaName = socialMediaObj.text();
      var baseInt = parseInt(baseData.medias[socialMediaName], 10);
      var compInt = parseInt(compData.medias[socialMediaName], 10);

      if (isNaN(baseInt)) {
        baseTd = '<td>?</td>';
      } else if (baseInt > compInt) {
        baseTd = '<td class="bold">' + baseInt + '</td>';
      } else {
        baseTd = '<td>' + baseInt + '</td>';
      }
      if (isNaN(compInt)) {
        compTd = '<td>?</td>';
      } else if (compInt > baseInt) {
        compTd = '<td class="bold">' + compInt + '</td>';
      } else {
        compTd = '<td>' + compInt + '</td>';
      }

      line = '<tr><td>' +
        $('<div>').append(socialMediaObj.clone()).html() +
        '</td>' + baseTd + compTd + '</tr>';
      return $content.find('tbody').append(line);
    });
    return $element
      .addClass('social-media-tab-content tab-content full-width')
      .html($content);
  }
}

module.exports = addMainDataInSIComp;
